import {
  Appointment,
  ParchiPatient,
  PatientProfile,
  TCreateAptPatient,
} from "@elixir/types";

export const convertParchiPatientToPatientProfile = (
  parchiPatient: ParchiPatient
): PatientProfile => {
  const { profile, id } = parchiPatient;
  const { personal } = profile;
  const { name, age, gender, phone } = personal;

  return {
    oid: id,
    fln: name,
    dob: age.dob,
    gen: gender,
    mobile: `${phone?.c}${phone?.n}`,
  } as unknown as PatientProfile;
  // TODO: Typecasting is necessary here as this is all the information we are receiving from parchi
};

export const convertPatientProfileToParchiPatient = (
  apt: Appointment
): ParchiPatient => {
  const patient = apt.patient;
  return {
    formData: apt.formData,
    id: patient.oid,
    profile: {
      personal: {
        onApp: [1, 2, 6].includes(patient?.type!),
        age: {
          dob: patient.dob!,
        },
        bloodgroup: "",
        gender: getParchiGenderFromAuthGender(patient.gen),
        name: patient.fln,
        phone: {
          c: patient.mobile?.slice(0, 3),
          n: patient.mobile?.slice(-10),
        },
      },
    },
    updated_at: patient.at,
    "health-ids": patient["health-ids"],
  };
};

function getParchiGenderFromAuthGender(
  gender: Appointment["patient"]["gen"]
): string {
  switch (gender) {
    case "M":
      return "male";
    case "F":
      return "female";
    case "O":
      return "others";
    default:
      return "male"; //Adding Just for code sanity. Gender would always exist in Auth Profile for doc tool cases
  }
}

export const getCreateAptPatientFromParchiProfile = (
  parchiPatient: ParchiPatient
): TCreateAptPatient => {
  const { profile, id, formData, abha } = parchiPatient;
  const { personal } = profile;
  const { name, age, gender, phone } = personal;

  return {
    oid: id,
    fln: name,
    dob: age.dob,
    gen: gender,
    mobile: (phone?.n && phone?.c) ? `${phone.c}${phone.n}` : '',
    formData: formData,
    abha: abha,
  };
};

export const Rupee = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});
